////////LIBRARY/////////
import React, { useRef, useState, Fragment } from 'react'
import styled from 'styled-components'
import PaperList from './PaperList'
import { Transition } from 'react-transition-group'
///////COMPONENTS///////
import UseOutsideClick from '../../hooks/UseOutsideClick/UseOutsideClick'
/////////ASSETS/////////
import SelectDropdownWhiteIcon from '../../assets/icones/global/select-dropdown-white.svg'
import SelectDropdownDefaultIcon from '../../assets/icones/global/select-dropdown-black.svg'
import ArrowUp from '../../assets/icones/global/arrow-up.svg'
import ArrowDown from '../../assets/icones/global/arrow-down.svg'

/////////STYLED/////////
const DropdownCheckboxWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	border-radius: 3px;
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	color: ${(props) => props.theme.colors.black}
	cursor: pointer;
	padding: 0px 40px 0px 10px;
	height: 32px;
	&::after {
		content: '';
		width: 32px;
		height: 100%;
		background-color: ${(props) => {
			if (props.eraserColor) {
				return props.theme.colors.eraser
			} else if (props.blueColor) {
				return props.theme.colors.primary
			} else {
				return props.theme.colors.dropdownDefault
			}
		}};
		pointer-events: none;
		position: absolute;
		border-radius: ${(props) => (props.reverseMode ? '3px 0px 0px 3px' : '0px 3px 3px 0px')};
		right: ${(props) => (props.reverseMode ? 'unset' : '0px')};
		left: ${(props) => (props.reverseMode ? '0px' : 'unset')};
		background-image: ${(props) => (props.blueColor || props.eraserColor ? `url('${SelectDropdownWhiteIcon}')` : `url('${SelectDropdownDefaultIcon}')`)};
		background-repeat: no-repeat;
		background-position: center;
		transition: background-color 0.1s;
	}
`
const ContentCheckBoxWrapper = styled.div`
	/*padding-top:2px;*/
`
const Paper = styled.div`
	height:45%;
    display: grid;
    grid-template-columns: max-content;
    grid-auto-rows: 40px;
    justify-content: stretch;
    align-items: stretch;
	
    padding: 0 20px;
	overflow-x: hidden;
	overflow-y : auto;
    max-height: 400px;
	overflow-y: auto;
	
::-webkit-scrollbar {
    width: 17px;
	height: 18px;
}
::-webkit-scrollbar-thumb {
    height: 6px;
	border-right: 10px solid rgba(0, 0, 0, 0);
	border-left:${(props) => props.theme.colors.backgroundScroll};
	border-top:${(props) => props.theme.colors.backgroundScroll},
	border-bottom:${(props) => props.theme.colors.backgroundScroll};
    background-clip: padding-box;
    background-color: ${(props) => props.theme.colors.eraser};
}
::-webkit-scrollbar-button:vertical:decrement:single-button {
	background: no-repeat${(props) => props.theme.colors.backgroundScroll};
	background-image: url(${ArrowUp});
	height:10px;
	background-position: center bottom;
	border-right: 10px solid white;
}
::-webkit-scrollbar-button:vertical:increment:single-button {
	background: no-repeat${(props) => props.theme.colors.backgroundScroll};
	background-image: url(${ArrowDown});
	height:10px;
	background-position: center bottom;
	border-right: 10px solid white;	
}
::-webkit-scrollbar-track-piece{
	background-color: ${(props) => props.theme.colors.backgroundScroll};
	border-right: 10px solid white;
}		
`
const DropdownCheckboxLabel = styled.label`
	line-height: 32px;
	margin-right: 5px;
`
const PaperWrapper = styled.div`
	padding: ${(props) => (props.dataSize > 10 ? ' 10px 0px 10px' : '')};
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	position: absolute;
	top: ${(props) => props.topPosition + 'px'};
	right: ${(props) => (props.rtl ? '0' : 'inherit')};
	left: ${(props) => (props.rtl ? 'inherit' : '0')};
	transition: all 50ms;
	z-index: 10;
	transform-origin: top;
	transform: scaleY(
		${({ menuTransition }) => {
			switch (menuTransition) {
				case 'entering':
					return '0'
				case 'entered':
					return '1'
				case 'exiting':
					return '0'
				case 'exited':
					return '0'
				default:
					return '0'
			}
		}}
	);
`
/////////STYLED/////////

const DropdownCheckbox = ({
	margin,
	data,
	width,
	paperTopPosition,
	upper,
	title,
	toTranslate,
	padding,
	rtl,
	selectActionsHandler,
	dropColor,
	submitOnClose,
	target,
	radio = false,
	eraserColor,
	label = '',
	pics = [],
}) => {
	const [showPaper, setShowPaper] = useState(false)
	const refDropdownCheckbox = useRef()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleShowPaper = () => {
		if (!showPaper) setShowPaper(true)
	}
	const handleClosePaperCheckbox = () => {
		submitOnClose()
		setShowPaper(false)
	}
	const checkBoxHandler = (id, checked, _target, _radio) => {
		selectActionsHandler(id, checked, target, radio)
		// In radio mode, when we click element, we close instantly the paper
		if (radio) {
			setShowPaper(false)
		}
	}

	UseOutsideClick(refDropdownCheckbox, handleClosePaperCheckbox)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{label.length > 0 && <DropdownCheckboxLabel>{label}</DropdownCheckboxLabel>}
			<DropdownCheckboxWrapper
				width={width}
				upper={upper}
				margin={margin}
				padding={padding}
				blueColor={dropColor}
				onClick={handleShowPaper}
				eraserColor={eraserColor}
			>
				<ContentCheckBoxWrapper>{title}</ContentCheckBoxWrapper>
				<Transition
					in={showPaper}
					timeout={{
						appear: 0,
						enter: 0,
						exit: 300,
					}}
					mountOnEnter
					unmountOnExit
				>
					{(state) => (
						<PaperWrapper topPosition={paperTopPosition} menuTransition={state} dataSize={data.length}>
							<Paper ref={refDropdownCheckbox} rtl={rtl}>
								<PaperList
									data={data}
									toTranslate={toTranslate}
									checkBoxHandler={checkBoxHandler}
									target={target}
									radio={radio}
									pics={pics}
								/>
							</Paper>
						</PaperWrapper>
					)}
				</Transition>
			</DropdownCheckboxWrapper>
		</Fragment>
	)
}

DropdownCheckbox.propTypes = {}

DropdownCheckbox.defaultPropTypes = {}

export default DropdownCheckbox
